import { Big } from '../lib/big.js';
import { formatNumber } from './formatNumber';
import { toNativeDigits } from './nativeDigits';

export function formatFeeBalance(value?: string) {
  const amount = new Big(value || 0);
  const rounded = amount.round(2, amount.lt(0) ? Big.roundUp : Big.roundDown);

  return toNativeDigits(formatNumber(rounded, 2, false, true));
}
